module.exports = __webpack_public_path__ + "static/media/glance4.46a9e758.jpeg";